// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
import { createI18n } from 'vue-i18n'
import langHelper from './helper'
import zhCN from './zh-cn' // 简体中文
import zhHK from './zh-hk' // 繁体中文
import { getUrlParamByName } from '@/utils/common'

// Vue.use(VueI18n)

// 多语言内容
const messages = {
  zh_CN: zhCN,
  zh_HK: zhHK
}

let locale = langHelper?langHelper.langKeyformat(langHelper.getInitLocale()):null
if(!locale){
  locale = localStorage.getItem("application_language") || navigator.language
    if (window.location.href.indexOf('lang=') !== -1) {
      locale = getUrlParamByName('lang')
    }
}

locale = Object.keys(messages).includes(locale) ? locale : 'zh_CN'
const i18n = createI18n({ locale, messages })
// export default new VueI18n({ locale, messages })


export default i18n;
